import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { DatabaseTableViewIcon } from '@blocksuite/icons/lit';
import { html } from 'lit';
import { property } from 'lit/decorators.js';

import type { DatabaseAttachment } from '../ai-chat-content/type';
import {
  getDatabaseAttachmentLabel,
  getDatabaseAttachmentTooltip,
} from './database-context-labels';

export class ChatPanelDatabaseChip extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor database!: DatabaseAttachment;

  @property({ attribute: false })
  accessor onRemove: ((database: DatabaseAttachment) => void) | undefined;

  override render() {
    const tooltip = this._getTooltip();

    const label = this._getLabel();

    return html`<chat-panel-chip
      .state=${'finished'}
      .name=${label}
      .tooltip=${tooltip}
      .icon=${DatabaseTableViewIcon()}
      .closeable=${!!this.onRemove}
      .onChipDelete=${this._handleRemove}
    ></chat-panel-chip>`;
  }

  private _getTooltip(): string {
    return getDatabaseAttachmentTooltip(this.database);
  }

  private _getLabel(): string {
    return getDatabaseAttachmentLabel(this.database);
  }

  private readonly _handleRemove = () => {
    this.onRemove?.(this.database);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'chat-panel-database-chip': ChatPanelDatabaseChip;
  }
}
